// import React, { useContext, useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import Form from "react-bootstrap/Form";
// import Select from "react-select";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { useForm } from "react-hook-form";
// import { Context } from "../../../../utils/context";

import { Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { Modal } from "react-bootstrap";

import React, { useContext, useEffect, useState } from "react";

import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";

import { useForm } from "react-hook-form";
import classNames from "classnames";
import ModalSave from "../../../common/ModalSave";
import { Context } from "../../../../utils/context";
import { Controller, useFieldArray } from "react-hook-form";
import AddedLottieModal from "../../../Hrms-Dashboard/commonLottie/AddedLottieModal";
import { useNavigate, useParams } from "react-router";
import { format, isBefore, isAfter } from "date-fns";
const Edit = () => {
  // const state = [
  //   { value: "Maharshtra", label: "Maharshtra" },
  //   { value: "Karnatak", label: "Karnatak" },
  //   { value: "Delhi", label: "Delhi" },
  // ];
  // const city = [
  //   { value: "Pune", label: "Pune" },
  //   { value: "Mumbai", label: "Mumbai" },
  //   { value: "Satara", label: "Satara" },
  // ];

  // const [startDate, setStartDate] = useState();
  // const [endDate, setEndDate] = useState();

  const { id } = useParams();

  const navigate = useNavigate();
  const [showLottie, setshowLottie] = useState(false);

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const { postData, Select2Data, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    watch,
    formState: { errors },
    getValues,
    setError,
  } = useForm({
    defaultValues: {
      thired_party_api: [],
    },
  });

  //
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray(
    {
      control,
      name: "thired_party_api",
    }
  );
  //

  const imageFile = watch("logo");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data?.name);
      sendData.append("email", data?.email);
      sendData.append("contact_no", data?.contact_no);
      sendData.append("whats_app_no", data?.whats_app_no);
      sendData.append("landline", data?.landline);
      sendData.append("country_id", data?.country_id?.value);
      sendData.append("state_id", data?.state_id?.value);
      sendData.append("city_id", data?.city_id?.value);
      sendData.append("business_name", data?.business_name);
      sendData.append("pan_no", data?.pan_no);
      sendData.append("gst_no", data?.gst_no);
      sendData.append("address", data?.address);
      sendData.append("ac_holder_name", data?.ac_holder_name);
      sendData.append("ac_no", data?.ac_no);
      sendData.append("branch_name", data?.branch_name);
      sendData.append("ifsc", data?.ifsc);
      sendData.append("license_s_date", data?.license_s_date);
      sendData.append("license_e_date", data?.license_e_date);
      sendData.append("license_no", data?.license_no);
      if (data?.password) {
        sendData.append("password", data?.password);
      }
      sendData.append("sub_domain", data?.sub_domain);
      sendData.append("database_name", data?.database_name);
      sendData.append("database_user_name", data?.database_user_name);
      sendData.append("database_password", data?.database_password);
      sendData.append(
        "thired_party_api",
        JSON.stringify(data?.thired_party_api)
      );

      if (data?.logo && data.logo.length > 0) {
        sendData.append("logo", data.logo[0]);
      }

      sendData.append("complaint", data?.complaint);
      sendData.append("hrms", data?.hrms);
      sendData.append("project", data?.project);
      sendData.append("lead", data?.lead);

      const response = await postData(
        `/super-admin/subscriptions/subscriptions/${id}`,
        sendData
      );

      if (response?.success) {
        setshowLottie(true);

        setTimeout(() => {
          setshowLottie(false);
          reset();
          navigate("/super-admin/subscriber");
        }, 2000);
      } else {
        if (response.message.email) {
          setError('email', { message: response.message.email });
        }
        if (response.message.mobile_number) {
          setError('contact_no', { message: response.message.contact_no });
        }
        setshowLottie();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const SelectCountryData = async (data, name, other = false) => {
    const result = data.map((data) => ({
      value: data?.id,
      label: data?.name,
      name: name,
      code: data?.country_code,
    }));

    if (other) {
      result.push({ value: "0", label: "Other", name: name, code: 'in' });
    }
    return result;
  };

  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);

  const GetAllCountry = async () => {
    const response = await getData("/masters/allcountry");
    if (response?.success) {
      setCountry(await SelectCountryData(response?.data, "country_id"));
    }
  };

  const GetAllState = async (id) => {
    const response = await getData(`/masters/allstate/${id}`);
    if (response?.success) {
      setState(await Select2Data(response?.data, "state_id"));
    }
  };

  const GetAllCity = async (id) => {
    const response = await getData(`/masters/allcity/${id}`);
    if (response?.success) {
      setCity(await Select2Data(response?.data, "city_id"));
    }
  };

  useEffect(() => {
    GetAllCountry();
    GetAllState();
    GetAllCity();
  }, []);

  useEffect(() => {
    GetEditData();
  }, [id]);

  const GetEditData = async () => {
    const response = await getData(
      `/super-admin/subscriptions/subscriptions/${id}`
    );
    // setStartDate(new Date(response?.data.license_s_date));
    // setEndDate(new Date(response?.data.license_e_date));


    if (response?.success) {
      setStartDate(new Date(response?.data?.license_s_date));
      setEndDate(new Date(response?.data?.license_e_date));
      reset(response?.data);
    }

    // const formatDateString = (dateString) => {
    //   // Split the input date string by '/'
    //   const parts = dateString.split("/");
    //   // Return a string in the format 'YYYY-MM-DD'
    //   return `${parts[2]}-${parts[1]}-${parts[0]}`; // 'YYYY-MM-DD'
    // };

    // const startDate = formatDateString(response?.data?.license_s_date);
    // const endDate = formatDateString(response?.data?.license_e_date);

    // // Set the dates
    // setStartDate(new Date(startDate));
    // setEndDate(new Date(endDate));
  };

  // ----------------------------------------------------------------
  useEffect(() => {
    // Validate end date whenever start date changes
    if (startDate && endDate) {
      if (isBefore(endDate, startDate)) {
        setValue("license_e_date", ""); // Clear end date if it is before start date
        setEndDate(null); // Reset endDate state
      }
    }
  }, [startDate, endDate, setValue]);
  return (
    <>
      <section className="maintablesec">
        <div className="addsection">
          <h6 className="addtitle">Edit Subscriber</h6>
        </div>

        <div className="addformseccc mt-5">
          <Form onSubmit={handleSubmit(onSubmit)} role="form">
            <div className="row">

              <div className="col-lg-4 mb-4">
                <Form.Label>Name</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Name"
                      className={classNames("", {
                        "is-invalid": errors?.name,
                      })}
                      {...register("name", {
                        required: "Name is required",
                      })}
                    />
                  </InputGroup>
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-4 mb-4">
                <Form.Label>Email</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="email"
                      placeholder="Email"
                      className={classNames("", {
                        "is-invalid": errors?.email,
                      })}
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/,
                          message: "Invalid Email address",
                        },
                        validate: (value) => {
                          // Extract the domain and TLD
                          const domainPattern = /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/;
                          const match = value.match(domainPattern);
                          if (match) {
                            const domainParts = match[1].split('.');
                            const tld = match[2];

                            // Ensure the domain and TLD are not the same
                            if (domainParts[domainParts.length - 1] === tld) {
                              return "Domain and top-level domain must be different";
                            }
                          }
                          return true;
                        }
                      })}
                      onKeyDown={(e) => {
                        if (e.key === ' ') {
                          e.preventDefault(); // Prevent space key press
                        }
                      }}
                    />
                  </InputGroup>
                  {errors.email && (
                    <span className="text-danger">{errors.email.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-4 mb-4">
                <Row className="row justify-content-center mb-2">
                  <Form.Label>Country</Form.Label>
                  <Controller
                    name="country_id"
                    {...register("country_id", {
                      required: "Select Country",
                    })}
                    control={control}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.country_id ? "red" : baseStyles,
                          }),
                        }}
                        {...field}
                        options={country}
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption.value);
                          GetAllState(selectedOption.value);
                          setValue("country_id", selectedOption);
                          setValue("state_id", "");
                          setValue("city_id", "");
                        }}
                      />
                    )}
                  />
                  {errors.category_id && (
                    <span className="text-danger">
                      {errors.category_id.message}
                    </span>
                  )}
                </Row>
              </div>

              <div className="col-lg-4 mb-4">
                <Row className="row justify-content-center mb-2">
                  <Form.Label>State</Form.Label>
                  <Controller
                    name="state_id"
                    {...register("state_id", {
                      required: "Select State",
                    })}
                    control={control}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.state_id ? "red" : baseStyles,
                          }),
                        }}
                        {...field}
                        options={state}
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption.value);
                          GetAllCity(selectedOption.value);
                          setValue("state_id", selectedOption);
                          setValue("city_id", "");
                        }}
                      />
                    )}
                  />
                  {errors.category_id && (
                    <span className="text-danger">
                      {errors.category_id.message}
                    </span>
                  )}
                </Row>
              </div>

              <div className="col-lg-4 mb-4">
                <Row className="row justify-content-center mb-2">
                  <Form.Label>City</Form.Label>
                  <Controller
                    name="city_id"
                    {...register("city_id", {
                      required: "Select City",
                    })}
                    control={control}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.city_id ? "red" : baseStyles,
                          }),
                        }}
                        {...field}
                        options={city}
                      />
                    )}
                  />
                  {errors.city_id && (
                    <span className="text-danger">
                      {errors.city_id.message}
                    </span>
                  )}
                </Row>
              </div>

              <div className="col-lg-4 mb-4">
                <Form.Label>Address</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="address"
                      placeholder="Address"
                      className={classNames("", {
                        "is-invalid": errors?.address,
                      })}
                      {...register("address", {
                        required: "Address is required",
                      })}
                    />
                  </InputGroup>
                  {errors.address && (
                    <span className="text-danger">
                      {errors.address.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-4 mb-4">
                <Form.Label>Mobile No</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <InputGroup>

                    <Controller
                      name="contact_no"
                      control={control}
                      render={({ field }) => (
                        <div className="field-select-holder" style={{ position: "relative" }}>
                          <PhoneInput
                            country={watch("country_id")?.code || "in"}
                            name="contact_no"
                            value={field.value}
                            onChange={(value) => field.onChange(value)}
                            placeholder="9870928822"
                            inputStyle={{
                              borderColor: errors.contact_no ? "red" : "black",
                            }}
                          />

                        </div>
                      )}
                      rules={{
                        required: "Contact No is required",
                        minLength: {
                          value: 10,
                          message: "Mobile No must be exactly 10 digits",
                        },
                        // maxLength: {
                        //   value: 10,
                        //   message: "Mobile No must be exactly 10 digits", 
                        // },
                      }}
                    />
                  </InputGroup>
                  {errors.contact_no && (
                    <span className="text-danger">
                      {errors.contact_no.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-4 mb-4">
                <Form.Label>WhatsApp No</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <InputGroup>

                    <Controller
                      name="whats_app_no"
                      control={control}
                      render={({ field }) => (
                        <div className="field-select-holder" style={{ position: "relative" }}>
                          <PhoneInput
                            country={watch("country_id")?.code || "in"}
                            name="whats_app_no"
                            value={field.value}
                            onChange={(value) => field.onChange(value)}
                            placeholder="9870928822"
                            inputStyle={{
                              borderColor: errors.whats_app_no ? "red" : "black",
                            }}
                          />

                        </div>
                      )}
                      rules={{
                        required: "WhatsApp No is required", // Required field validation
                        minLength: {
                          value: 10,
                          message: "WhatsApp No must be exactly 10 digits", // Min length validation
                        },
                        // maxLength: {
                        //   value: 10,
                        //   message: "WhatsApp No must be exactly 10 digits", // Max length validation
                        // },
                      }}
                    />
                  </InputGroup>
                  {errors.whats_app_no && (
                    <span className="text-danger">
                      {errors.whats_app_no.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-4 mb-4">
                <Form.Label>Landline No</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <InputGroup>

                    <Form.Control
                      type="text"
                      name="landline"
                      // maxLength={10}
                      placeholder="Landline No"
                      className={classNames("", {
                        "is-invalid": errors?.landline,
                      })}
                      {...register("landline", {
                        required: "Landline No is required",
                        pattern: {
                          value: /^[0-9]*$/,
                          message: "Only numbers are allowed",
                        },
                        // minLength: {
                        //   value: 10,
                        //   message: "Landline No must be exactly 10 digits",
                        // },
                        // maxLength: {
                        //   value: 10,
                        //   message: "Landline No must be exactly 10 digits",
                        // },
                      })}
                      onKeyPress={(e) => {
                        // Prevent non-numeric input
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </InputGroup>
                  {errors.landline && (
                    <span className="text-danger">
                      {errors.landline.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-4 mb-4">
                <Form.Label>Company  Name</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="business_name"
                      placeholder="Company Name"
                      className={classNames("", {
                        "is-invalid": errors?.business_name,
                      })}
                      {...register("business_name", {
                        required: "Company Name is required",
                      })}
                    />
                  </InputGroup>
                  {errors.business_name && (
                    <span className="text-danger">
                      {errors.business_name.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-4 mb-4">
                <Form.Label>Pan No</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="pan_no"
                      placeholder="Pan No"
                      className={classNames("", {
                        "is-invalid": errors?.pan_no,
                      })}
                      {...register("pan_no", {
                        required: "Pan No is required",
                        pattern: {
                          value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, // Regular expression for PAN format
                          message: "Invalid PAN number format", // Error message
                        },
                      })}
                      onChange={(e) => {
                        e.target.value = e.target.value.toUpperCase();
                      }}
                      onKeyDown={(e) => {
                        if (e.key === ' ') {
                          e.preventDefault();
                        }
                        if (/[^A-Za-z0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </InputGroup>
                  {errors.pan_no && (
                    <span className="text-danger">{errors.pan_no.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-4 mb-4">
                <Form.Label>Gst No</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="gst_no"
                      placeholder="GST"
                      className={classNames("", {
                        "is-invalid": errors?.gst_no,
                      })}
                      {...register("gst_no", {
                        required: "GST is required",
                        pattern: {
                          value:
                            /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[1-9A-Z]{1}$/,
                          message: "Invalid GST Number",
                        },
                      })}
                      onChange={(e) => {
                        e.target.value = e.target.value.toUpperCase();
                      }}
                      onKeyDown={(e) => {
                        if (e.key === ' ') {
                          e.preventDefault();
                        }
                        if (/[^A-Za-z0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </InputGroup>
                  {errors.gst_no && (
                    <span className="text-danger">{errors.gst_no.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-4 mb-4">
                <Form.Label>Account Holder Name</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="ac_holder_name"
                      placeholder="Account Holder Name"
                      className={classNames("", {
                        "is-invalid": errors?.ac_holder_name,
                      })}
                      {...register("ac_holder_name", {
                        required: "Account Holder Name is required",
                      })}
                    />
                  </InputGroup>
                  {errors.ac_holder_name && (
                    <span className="text-danger">
                      {errors.ac_holder_name.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-4 mb-4">
                <Form.Label>Account Number</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="ac_no"
                      placeholder="Account Number"
                      className={classNames("", {
                        "is-invalid": errors?.ac_no,
                      })}
                      {...register("ac_no", {
                        required: "Account Number is required",
                      })}
                      onChange={(e) => {
                        e.target.value = e.target.value.toUpperCase();
                      }}
                    />
                  </InputGroup>
                  {errors.ac_no && (
                    <span className="text-danger">{errors.ac_no.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-4 mb-4">
                <Form.Label>Bank Name</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="bank_name"
                      placeholder="Bank Name"
                      className={classNames("", {
                        "is-invalid": errors?.bank_name,
                      })}
                      {...register("bank_name", {
                        required: "Bank Name is required",
                      })}
                    />
                  </InputGroup>
                  {errors.bank_name && (
                    <span className="text-danger">
                      {errors.bank_name.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-4 mb-4">
                <Form.Label>Branch Name</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="branch_name"
                      placeholder="Branch Name"
                      className={classNames("", {
                        "is-invalid": errors?.branch_name,
                      })}
                      {...register("branch_name", {
                        required: "Branch Name is required",
                      })}
                    />
                  </InputGroup>
                  {errors.branch_name && (
                    <span className="text-danger">
                      {errors.branch_name.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-4 mb-4">
                <Form.Label>IFSC Code</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="ifsc"
                      placeholder="IFSC Code"
                      className={classNames("", {
                        "is-invalid": errors?.ifsc,
                      })}
                      {...register("ifsc", {
                        required: "IFSC Code is required",
                      })}
                      onChange={(e) => {
                        e.target.value = e.target.value.toUpperCase();
                      }}
                    />
                  </InputGroup>
                  {errors.ifsc && (
                    <span className="text-danger">{errors.ifsc.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-4 mb-4">
                <Form.Label>Password</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <InputGroup>
                    <Form.Control
                      type="name"
                      name="password"
                      placeholder="Password"
                      className={classNames("", {
                        "is-invalid": errors?.password,
                      })}
                      {...register("password", {
                        // required: "Password is required",
                      })}
                    />
                  </InputGroup>
                  {errors.password && (
                    <span className="text-danger">
                      {errors.password.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-4 mb-4">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <InputGroup>
                    <Form.Control
                      type="name"
                      name="confirm_password"
                      placeholder="Confirm Password"
                      className={classNames("", {
                        "is-invalid": errors?.confirm_password,
                      })}
                      {...register("confirm_password", {
                        // required: "Confirm password is required",
                        validate: (value) =>
                          value === watch("password") ||
                          "Passwords do not match",
                      })}
                    />
                  </InputGroup>
                  {errors.confirm_password && (
                    <span className="text-danger">
                      {errors.confirm_password.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-lg-4 mb-4">
                <Row className="justify-content-start">
                  <Form.Label className="text-left">logo</Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.logo,
                      })}
                      type="file"
                      {...register("logo", {
                        // required: "Image is required",
                        validate: async (value) => {
                          if (typeof value !== "string") {
                            const fileTypes = ["jpg", "png", "jpeg"];
                            const fileType = value[0].name?.split(".")[1];

                            if (!fileTypes.includes(fileType)) {
                              return `please upload a valid file format. (${fileTypes})`;
                            }

                            // const sizes = await getDimension(value[0]);
                            // if (sizes.width !== 1296 && sizes.height !== 465) {
                            //   return "Image width and height must be 1296 px and 465 px";
                            // }

                            // const fileSize = Math.round(
                            //   value[0].size / 1024
                            // );
                            // if (fileSize > 500) {
                            //   return "file size must be lower than 500kb";
                            // }
                          }
                        },
                      })}
                      accept=".jpg, .jpeg, .png"
                    />
                  </Form.Group>
                  {errors?.logo && (
                    <span className="text-danger">{errors.logo.message}</span>
                  )}
                </Row>
              </div>

              <Col className="main-form-section mt-3">
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Logo Preview</Form.Label>

                    {typeof getValues("logo") == "string" ? (
                      <div className="image-preview-container mt-3">
                        <img
                          // src={URL.createObjectURL(getValues("image")[0])}
                          src={IMG_URL + getValues("logo")}
                          alt="Preview"
                          className="image-preview"
                          width={"100px"}
                          height={"100px"}
                        />
                      </div>
                    ) : (
                      imageFile &&
                      imageFile?.length > 0 && (
                        <div className="image-preview-container mt-3">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(imageFile[0])}
                            alt="Preview"
                            className="image-preview"
                            width={"100px"}
                            height={"100px"}
                          />
                        </div>
                      )
                    )}

                  </Row>
                </div>
              </Col>


              <div className="col-lg-12 mb-4 text-center">
                <Form.Group className="form-group">
                  {" "}
                  <button type="submit" className="submit-btn btn me-2">
                    Submit
                  </button>
                  <button
                    type="button"
                    className="submit-btn btn"
                    onClick={() => navigate(`/super-admin/subscriber`)}
                  >
                    Close
                  </button>
                </Form.Group>
              </div>
            </div>
          </Form>
        </div>
      </section>
      <AddedLottieModal
        pageTitle="Subscription Updated"
        show={showLottie}
        onHide={() => setshowLottie(false)}
      />
    </>
  );
};

export default Edit;
